import React from 'react';
import { parseGroupingBy } from 'react-linechart';

const moment = require('moment');
var isLessThanOneDay = false;
const hourRange = 1

export function organiseData(measures, id) {
    var value = []
    for (var i = 0; i < measures.length; i++) {
        value.push({ id: id, x: measures[i].timestamp, y: measures[i].value })
    }
    return value
}

export function isInHourRange(hour, reference) {
    console.log(hour)
    console.log(reference)
    if (hour.split(':')[0] + hourRange == reference.split(':')[0] ||
        hour.split(':')[0] - hourRange == reference.split(':')[0] ||
        hour.split(':')[0] === reference.split(':')[0]
    ) {
        return true
    }
    return false
}

export function parsePressure(data1, data2, startDate, endDate, time) {
    var measures = []
    var dateValue;
    var data = [data1, data2]
    for (var y = 0; y < data.length; y++) {
        for (var i = 0; i < data[y].length; i++) {

            dateValue = new Date(data[y][i].x).toISOString().split('T')[0]
            if (dateValue >= startDate
                && dateValue <= endDate) {
                if (time === null) {
                    measures.push({ id: data[y][i].id, x: new Date(data[y][i].x), y: data[y][i].y })
                } else if (isInHourRange(data[y][i].x.split(' ')[1], time, 5)) {
                    measures.push({ id: data[y][i].id, x: new Date(data[y][i].x), y: data[y][i].y })
                }
            }
        }
    }


    return parseGroupingBy(measures, "x", "y", "id");
}

export function parseHeartRate(data, startDate, endDate, time) {
    var measures = []
    var dateValue;
    for (var i = 0; i < data.length; i++) {
        dateValue = new Date(data[i].timestamp).toISOString().split('T')[0]
        if (dateValue >= startDate
            && dateValue <= endDate) {
            if (time === null) {
                measures.push({ x: new Date(data[i].timestamp), y: data[i].value })
            } else if (isInHourRange(data[i].timestamp.split(' ')[1], time)) {
                measures.push({ x: new Date(data[i].timestamp), y: data[i].value })
            }
        }
    }

    return parseGroupingBy(measures, "x", "y", "id");
}

export function updateData(event) {
    this.state.time = null
    this.state.hidePoints = true
    var start = moment(this.state.startDate);
    var end = moment(this.state.endDate);
    if (event.target.id === "date-from") {
        this.setState({ startDate: event.target.value })
        start = moment(event.target.value);
    } else if (event.target.id === "date-to") {
        this.setState({ endDate: event.target.value })
        end = moment(event.target.value);
    }

    if (end.diff(start, 'days') <= 1) {
        isLessThanOneDay = true;
    } else {
        isLessThanOneDay = false;
    }
}

export function parsePressureEvent(data) {
    var datetime = data.timestamp.split(' ');
    var date = datetime[0];
    var time = datetime[1];
    var msg;
    if (data.type === 'diastolic') {
        msg = ' diastolic blood pressure went higher than ';
    } else if (data.type === 'systolic') {
        msg = ' systolic blood pressure went higher than ';
    }

    return <div>
        <p>
            <span className={"event-date"}>{date}</span>
            <span className={"event-time"}>{time}</span>
        </p>
        <p className="event-msg">{msg}<span className="threshold">{data.threshold}</span></p>
    </div>
}

export function parseHeartEvent(data, timeRef) {
    const msg = ' heart rate went higher than ';
    var datetime = data.timestamp.split(' ');
    var date = datetime[0];
    var time = datetime[1];

    return <div>
        <p>
            <span className={"event-date"}>{date}</span>
            <span className={"event-time"}>{time}</span>
        </p>
        <p className="event-msg">{msg}<span className="threshold">{data.threshold}</span></p>
    </div>
}

export function getXDisplay(value) {
    if (isLessThanOneDay) {
        return moment(new Date(value)).format("HH:mm");
    } else {
        return moment(new Date(value)).format("DD-HH:mm");
    }
}


// WEBPACK FOOTER //
// ./src/helpers/graph.js